
import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { SocialButtons } from '../../components/social-buttons/SocialButtons';
import { useForm } from '../../core/useForm';
import { Utils } from '../../core/Utils';

import "./Finish.scss";



export const Finish = ()=>{
    let history = useHistory();
    let  param:{codeform:string}  = useParams();
    const {form} = useForm(param.codeform,history);



    return <><div className="container-finish">{
           !form ? 
            
                <CircularProgress color="primary" />
             :
             <> 
                <>{/*<div> <LogoForm  logobase64={form.image}  /></div>*/}</>
               <div className="container-end">
              
                    <div  dangerouslySetInnerHTML={Utils.innerHTML(form.description)}></div>
               </div>
               <SocialButtons  form={form} />
             </>
             
            }</div>
            
            </>
}